import {
  Text,
  Box,
  VStack,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import {IconAlertCircle} from '../../../../../styles/icons';
import {useState, useEffect, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import {
  profileAccordionButton,
  profileAccordionPanel,
  sectionStyleEditing2,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import Lozenge from '../../../../components/common/Lozenge';
import { useUtilityDataSelector } from '../../../../utilities/contexts';
import {updateProfileValue} from "../../../../redux/actions/user";

const EditSectionPracticeAreas = ({ profile }) => {
  const allPracticeAreas = useUtilityDataSelector((utilityData) => utilityData.therapistPracticeAreas);
  const [practiceAreaSelection, setPracticeAreaSelection] = useState(allPracticeAreas);

  useEffect(() => {
    if (allPracticeAreas !== undefined) {
      let newArr = allPracticeAreas?.map((item) => {
        return profile?.practiceAreas
          ?.map((elem) => elem.value)
          .includes(item.value)
          ? { ...item, selected: true }
          : { ...item, selected: false };
      });
      setPracticeAreaSelection(newArr);
    }
  }, [allPracticeAreas, profile]);

  const dispatch = useDispatch();

  const handleProfileValueUpdate = useCallback((value) => {
    setPracticeAreaSelection(value);

    dispatch(updateProfileValue('practiceAreas', value.filter((elem) => elem.selected)))
  }, [dispatch]);

  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            textAlign="left"
          >
            <Box>
              <Text>Areas of expertise</Text>
              <Text textStyle="footer2" color="brand.200">
                {profile.practiceAreas.map((elem) => elem.label).join(' | ')}
              </Text>
            </Box>
            {profile.practiceAreas?.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato"/>
                <Text fontSize="14px" paddingLeft="8px">
                  Select your areas of expertise
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon/>
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <h3 className="text-lg text-slate-600 font-bold flex items-center">
              Which areas do you specialise in?
              <p className="text-red-500 superscript text-sm pl-1">*</p>
            </h3>
            <h5 className="pb-4 text-sm text-slate-600 font-light">
              You can select up to 12 options that apply to your practice
            </h5>

          <Lozenge
            title=""
            data={practiceAreaSelection}
            onclick={handleProfileValueUpdate}
            multi
            max={12}
          />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionPracticeAreas;
